export default "__VITE_ASSET__BCCCl43d__"